// i18nTexto.js — Campos traducibles que viven en columnas de la base de datos.
//
// Los títulos del Curso Mentor (curso, módulo, lección) se guardan en `titulo`
// más una columna `titulo_i18n` con sus traducciones: {"pt": "…", "en": "…"}.
// `conI18n` devuelve lo que espera `tl()`: un objeto con el idioma base ya
// puesto, de modo que si falta la traducción se ve el texto original.
//
//   tl(conI18n(modulo, 'titulo'))
//
// Un registro sin traducciones devuelve la cadena tal cual, así que los
// proyectos que no traduzcan nada se comportan igual que antes.
export const conI18n = (obj, campo = 'titulo') => {
  if (!obj) return '';
  const base = obj[campo];
  let trad = obj[`${campo}_i18n`];
  if (typeof trad === 'string') {
    try { trad = JSON.parse(trad); } catch (_) { trad = null; }
  }
  if (!trad || typeof trad !== 'object' || Object.keys(trad).length === 0) return base;
  // El idioma base manda salvo que la traducción lo redefina.
  return { es: base, ...trad };
};

export default conI18n;
